// Определение модуля "main"
const main = {
  namespaced: true,
  state() {
    return {
      PAGE_TITLE: '',
      SUBTITLE: '',
      BREADCRUMB_ITEMS: [],
      CITY_ID:0,
      USER:{
        CITY_ID:3,
      }
    };
  },
  mutations: {
    SET_PAGE_TITLE(state, title) {
      state.PAGE_TITLE = title;
    },
    SET_SUBTITLE(state, subtitle) {
      state.SUBTITLE = subtitle;
    },
    SET_BREADCRUMB_ITEMS(state, items) {
      state.BREADCRUMB_ITEMS = items;
    },
    SET_CITY_ID(state, id) {
      state.CITY_ID = id;
    },
    SET_USER(state, user) {
      state.USER = user;
    },
  },
  getters: {
    GET_PAGE_TITLE: state => state.PAGE_TITLE,
    GET_SUBTITLE: state => state.SUBTITLE,
    GET_BREADCRUMB_ITEMS: state => state.BREADCRUMB_ITEMS,
    GET_CITY_ID: state => state.CITY_ID,
    GET_USER: state => state.USER,
  },
};
export default main;